import { Pagination, PaginationV3Resource } from '../../types/paginations'

export const transformToPagination = (resource: PaginationV3Resource): Pagination => ({
    number: resource.currentPage + 1,
    pages: Math.ceil(resource.count / resource.items),
    size: resource.items,
})
